import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'

Vue.use(BootstrapVue);
Vue.config.productionTip = false

var initialVars = document.querySelector("#reclaim-video").dataset;

/* eslint-disable no-new */
new Vue({
  el: '#reclaim-video',
  render: h => h(App, {
    props: initialVars
  })
})



// WEBPACK FOOTER //
// ./src/main.js